import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./MapServices.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import {
  gsap,
  Power2,
  MotionPathPlugin
} from 'gsap/all';
gsap.registerPlugin(Power2);
gsap.registerPlugin(MotionPathPlugin);
const Map = () => {

  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { stage, updateTransition } = state;
  const [init, setInit] = useState(false);
  const [timeline, setTimeline] = useState(null);
  const [localStage, setLocalStage] = useState(0);
  const [transition, setTransition] = useState(false);
  const refWrap = useRef(null);
  const refOverlay = useRef(null);
  const refContainer = useRef(null);
  const refBody1 = useRef(null);
  const refBody2 = useRef(null);
  const refBody3 = useRef(null);
  const refBody4 = useRef(null);
  const refBg = useRef(null);
  const refBgOverlay = useRef(null);
  const refBgOverlay2 = useRef(null);
  const refSvg1 = useRef(null);
  const refRouts_out_1 = useRef(null);
  const refRouts_out_2 = useRef(null);
  const refRouts_out_3 = useRef(null);
  const refRouts_out_4 = useRef(null);
  const refRouts_out_5 = useRef(null);
  const refRouts_out_6 = useRef(null);
  const refRouts_out_7 = useRef(null);
  const refRouts_out_8 = useRef(null);
  const refRouts_out_9 = useRef(null);
  const refRouts_out_10 = useRef(null);
  const refRouts_out_11 = useRef(null);
  const refRoute_top_1 = useRef(null);
  const refRoute_top_2 = useRef(null);
  const refRoute_top_3 = useRef(null);
  const refRoute_top_4 = useRef(null);
  const refRoute_top_5 = useRef(null);
  const refRoute_top_6 = useRef(null);
  const refRoute_top_7 = useRef(null);
  const refRoute_top_8 = useRef(null);
  const refRoute_top_9 = useRef(null);
  const refRoute_top_10 = useRef(null);
  const refRoute_top_11 = useRef(null);
  const refRoute_right_1 = useRef(null);
  const refRoute_left_1 = useRef(null);
  const refRoute_left_2 = useRef(null);
  const refRoute_left_3 = useRef(null);
  const refMiniroute_1 = useRef(null);
  const refMiniroute_2 = useRef(null);
  const refMiniroute_3 = useRef(null);
  const refMiniroute_4 = useRef(null);
  const refMiniroute_5 = useRef(null);
  const refMiniroute_6 = useRef(null);
  const refMiniroute_7 = useRef(null);
  const refMiniroute_8 = useRef(null);
  const refMiniroute_9 = useRef(null);
  const refMiniroute_10 = useRef(null);
  const refMiniroute_11 = useRef(null);
  const refMiniroute_12 = useRef(null);
  const refDot_1 = useRef(null);
  const refDot_2 = useRef(null);
  const refDot_3 = useRef(null);
  const refDot_4 = useRef(null);
  const refDot_5 = useRef(null);
  const refDot_6 = useRef(null);
  const refDot_7 = useRef(null);
  const refDot_8 = useRef(null);
  const refDot_9 = useRef(null);
  const refDot_10 = useRef(null);
  const refDot_11 = useRef(null);
  const refDot_12 = useRef(null);
  const refRoute_main = useRef(null);
  const refRoute_main2 = useRef(null);
  const refRoute_main_mask = useRef(null);
  const refRoute_main_mask2 = useRef(null);
  const refLabels = useRef([]);
  const refCities = useRef([]);

  useEffect(() => {
    const tl = gsap.timeline({ paused: true });
    const wrap = refWrap.current;
    const body1 = refBody1.current;
    const body2 = refBody2.current;
    const body3 = refBody3.current;
    const body4 = refBody4.current;
    const svg1 = refSvg1.current;
    const overlay = refOverlay.current;
    const container = refContainer.current;
    const bgOverlay = refBgOverlay.current;
    const city1 = refCities.current[0];
    const city2 = refCities.current[1];
    const city3 = refCities.current[2];
    const city4 = refCities.current[3];
    const city5 = refCities.current[4];
    const city6 = refCities.current[5];
    const city7 = refCities.current[6];
    const city8 = refCities.current[7];
    const city9 = refCities.current[8];
    const city10 = refCities.current[9];
    const city11 = refCities.current[10];
    const city12 = refCities.current[11];
    const city13 = refCities.current[12];
    const city14 = refCities.current[13];
    const label1 = refLabels.current[0];
    const label2 = refLabels.current[1];
    const label3 = refLabels.current[2];
    const label4 = refLabels.current[3];
    const label5 = refLabels.current[4];
    const label6 = refLabels.current[5];
    const label7 = refLabels.current[6];
    const label8 = refLabels.current[7];
    const label9 = refLabels.current[8];
    const label10 = refLabels.current[9];
    const label11 = refLabels.current[10];
    const label12 = refLabels.current[11];
    const route_top_1 = refRoute_top_1.current;
    const route_top_2 = refRoute_top_2.current;
    const route_top_3 = refRoute_top_3.current;
    const route_top_4 = refRoute_top_4.current;
    const route_top_5 = refRoute_top_5.current;
    const route_top_6 = refRoute_top_6.current;
    const route_top_7 = refRoute_top_7.current;
    const route_top_8 = refRoute_top_8.current;
    const route_top_9 = refRoute_top_9.current;
    const route_top_10 = refRoute_top_10.current;
    const route_top_11 = refRoute_top_11.current;
    const route_out_1 = refRouts_out_1.current;
    const route_out_2 = refRouts_out_2.current;
    const route_out_3 = refRouts_out_3.current;
    const route_out_4 = refRouts_out_4.current;
    const route_out_5 = refRouts_out_5.current;
    const route_out_6 = refRouts_out_6.current;
    const route_out_7 = refRouts_out_7.current;
    const route_out_8 = refRouts_out_8.current;
    const route_out_9 = refRouts_out_9.current;
    const route_out_10 = refRouts_out_10.current;
    const route_out_11 = refRouts_out_11.current;
    const route_right_1 = refRoute_right_1.current;
    const route_left_1 = refRoute_left_1.current;
    const route_left_2 = refRoute_left_2.current;
    const route_left_3 = refRoute_left_3.current;
    const miniroute_1 = refMiniroute_1.current;
    const miniroute_2 = refMiniroute_2.current;
    const miniroute_3 = refMiniroute_3.current;
    const miniroute_4 = refMiniroute_4.current;
    const miniroute_5 = refMiniroute_5.current;
    const miniroute_6 = refMiniroute_6.current;
    const miniroute_7 = refMiniroute_7.current;
    const miniroute_8 = refMiniroute_8.current;
    const miniroute_9 = refMiniroute_9.current;
    const miniroute_10 = refMiniroute_10.current;
    const miniroute_11 = refMiniroute_11.current;
    const miniroute_12 = refMiniroute_12.current;
    const dot_1 = refDot_1.current;
    const dot_2 = refDot_2.current;
    const dot_3 = refDot_3.current;
    const dot_4 = refDot_4.current;
    const dot_5 = refDot_5.current;
    const dot_6 = refDot_6.current;
    const dot_7 = refDot_7.current;
    const dot_8 = refDot_8.current;
    const dot_9 = refDot_9.current;
    const dot_10 = refDot_10.current;
    const dot_11 = refDot_11.current;
    const dot_12 = refDot_12.current;
    const route_main = refRoute_main.current;
    const route_main2 = refRoute_main2.current;
    const route_main_mask = refRoute_main_mask.current;
    const route_main_mask2 = refRoute_main_mask2.current;

    tl
      .to(wrap, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 })
      .to(overlay, { duration: 0.1, ease: 'power2.inOut', scale: 1, autoAlpha: 1 }, '-=0.1')
      .to(container, { duration: 0.1, ease: 'power2.inOut', scale: 1.5, x: '-50%', y: '-50%' }, '-=0.1')
      .to(label1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label4, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label5, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label6, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label7, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label8, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label9, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label10, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label11, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(label12, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(bgOverlay, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(svg1, { duration: 0.1, ease: 'power2.inOut', scale: '1', autoAlpha: 0 }, '-=0.1')
      .to(body1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.1')
      .to(body2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(body3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(body4, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 }, '-=0.1')
      .to(city1, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city2, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city3, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city4, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city5, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city6, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city7, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city8, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city9, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city10, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city11, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city12, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city13, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(city14, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_1, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_2, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_3, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_4, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_5, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_6, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_7, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_8, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_9, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_10, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_11, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(dot_12, { duration: 0.1, autoAlpha: 0 }, '-=0.1')
      .to(route_top_1, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_1.getTotalLength(), strokeDashoffset: route_top_1.getTotalLength() }, '-=0.1')
      .to(route_top_2, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_2.getTotalLength(), strokeDashoffset: route_top_2.getTotalLength() }, '-=0.1')
      .to(route_top_3, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_3.getTotalLength(), strokeDashoffset: route_top_3.getTotalLength() }, '-=0.1')
      .to(route_top_4, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_4.getTotalLength(), strokeDashoffset: route_top_4.getTotalLength() }, '-=0.1')
      .to(route_top_5, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_5.getTotalLength(), strokeDashoffset: route_top_5.getTotalLength() }, '-=0.1')
      .to(route_top_6, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_6.getTotalLength(), strokeDashoffset: route_top_6.getTotalLength() }, '-=0.1')
      .to(route_top_7, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_7.getTotalLength(), strokeDashoffset: route_top_7.getTotalLength() }, '-=0.1')
      .to(route_top_8, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_8.getTotalLength(), strokeDashoffset: route_top_8.getTotalLength() }, '-=0.1')
      .to(route_top_9, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_9.getTotalLength(), strokeDashoffset: route_top_9.getTotalLength() }, '-=0.1')
      .to(route_top_10, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_10.getTotalLength(), strokeDashoffset: route_top_10.getTotalLength() }, '-=0.1')
      .to(route_top_11, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_top_11.getTotalLength(), strokeDashoffset: route_top_11.getTotalLength() }, '-=0.1')
      .to(route_out_1, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_1.getTotalLength(), strokeDashoffset: route_out_1.getTotalLength() }, '-=0.1')
      .to(route_out_2, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_2.getTotalLength(), strokeDashoffset: route_out_2.getTotalLength() }, '-=0.1')
      .to(route_out_3, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_3.getTotalLength(), strokeDashoffset: route_out_3.getTotalLength() }, '-=0.1')
      .to(route_out_4, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_4.getTotalLength(), strokeDashoffset: route_out_4.getTotalLength() }, '-=0.1')
      .to(route_out_5, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_5.getTotalLength(), strokeDashoffset: route_out_5.getTotalLength() }, '-=0.1')
      .to(route_out_6, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_6.getTotalLength(), strokeDashoffset: route_out_6.getTotalLength() }, '-=0.1')
      .to(route_out_7, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_7.getTotalLength(), strokeDashoffset: route_out_7.getTotalLength() }, '-=0.1')
      .to(route_out_8, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_8.getTotalLength(), strokeDashoffset: route_out_8.getTotalLength() }, '-=0.1')
      .to(route_out_9, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_9.getTotalLength(), strokeDashoffset: route_out_9.getTotalLength() }, '-=0.1')
      .to(route_out_10, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_10.getTotalLength(), strokeDashoffset: route_out_10.getTotalLength() }, '-=0.1')
      .to(route_out_11, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_out_11.getTotalLength(), strokeDashoffset: route_out_11.getTotalLength() }, '-=0.1')
      .to(route_right_1, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_right_1.getTotalLength(), strokeDashoffset: route_right_1.getTotalLength() * 2 - route_right_1.getTotalLength() }, '-=0.1')
      .to(route_left_1, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_left_1.getTotalLength(), strokeDashoffset: route_left_1.getTotalLength() * 2 - route_left_1.getTotalLength() }, '-=0.1')
      .to(route_left_2, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_left_2.getTotalLength(), strokeDashoffset: route_left_2.getTotalLength() * 2 - route_left_2.getTotalLength() }, '-=0.1')
      .to(route_left_3, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_left_3.getTotalLength(), strokeDashoffset: route_left_3.getTotalLength() * 2 - route_left_3.getTotalLength() }, '-=0.1')
      .to(route_main, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_main.getTotalLength(), strokeDashoffset: route_main.getTotalLength() / 2 }, '-=0.1')
      .to(route_main2, { duration: 0.1, visibility: 'hidden', strokeDasharray: route_main.getTotalLength(), strokeDashoffset: route_main.getTotalLength() * 2 - route_main.getTotalLength() / 2 }, '-=0.1')
      .to(route_main_mask, { duration: 0.1, strokeDasharray: route_main_mask.getTotalLength(), strokeDashoffset: route_main_mask.getTotalLength() * 2 - route_main_mask.getTotalLength() / 2 }, '-=0.1')
      .to(route_main_mask2, { duration: 0.1, strokeDasharray: route_main_mask2.getTotalLength(), strokeDashoffset: route_main_mask2.getTotalLength() / 2 }, '-=0.1')
      .to(miniroute_1, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_1.getTotalLength(), strokeDashoffset: miniroute_1.getTotalLength() }, '-=0.1')
      .to(miniroute_2, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_2.getTotalLength(), strokeDashoffset: miniroute_2.getTotalLength() }, '-=0.1')
      .to(miniroute_3, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_3.getTotalLength(), strokeDashoffset: miniroute_3.getTotalLength() }, '-=0.1')
      .to(miniroute_4, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_4.getTotalLength(), strokeDashoffset: miniroute_4.getTotalLength() }, '-=0.1')
      .to(miniroute_5, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_5.getTotalLength(), strokeDashoffset: miniroute_5.getTotalLength() }, '-=0.1')
      .to(miniroute_6, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_6.getTotalLength(), strokeDashoffset: miniroute_6.getTotalLength() }, '-=0.1')
      .to(miniroute_7, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_7.getTotalLength(), strokeDashoffset: miniroute_7.getTotalLength() }, '-=0.1')
      .to(miniroute_8, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_8.getTotalLength(), strokeDashoffset: miniroute_8.getTotalLength() }, '-=0.1')
      .to(miniroute_9, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_9.getTotalLength(), strokeDashoffset: miniroute_9.getTotalLength() }, '-=0.1')
      .to(miniroute_10, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_10.getTotalLength(), strokeDashoffset: miniroute_10.getTotalLength() }, '-=0.1')
      .to(miniroute_11, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_11.getTotalLength(), strokeDashoffset: miniroute_11.getTotalLength() }, '-=0.1')
      .to(miniroute_12, { duration: 0.1, visibility: 'hidden', strokeDasharray: miniroute_12.getTotalLength(), strokeDashoffset: miniroute_12.getTotalLength() }, '-=0.1')
      .add('stage-0')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 0 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1 }, '-=1')
      .to(svg1, { duration: 0.1, autoAlpha: 1 })
      .to(route_main, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=0.1')
      .to(route_main2, { duration: 1, visibility: 'visible', strokeDashoffset:  route_main2.getTotalLength() * 2 }, '-=1')
      .to(route_right_1, { duration: 1, visibility: 'visible', strokeDashoffset: route_right_1.getTotalLength() * 2 }, '-=0.6')
      .to(route_left_1, { duration: 1, visibility: 'visible', strokeDashoffset:  route_left_1.getTotalLength() * 2 }, '-=1')
      .to(route_left_2, { duration: 1, visibility: 'visible', strokeDashoffset:  route_left_2.getTotalLength() * 2 }, '-=1')
      .to(route_left_3, { duration: 1, visibility: 'visible', strokeDashoffset: route_left_3.getTotalLength() * 2 }, '-=1')
      .to(dot_1, { duration: 0.5, autoAlpha: 1 })
      .to(dot_2, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_3, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_4, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_11, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_12, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label1, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label2, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label3, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label4, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label11, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label12, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(miniroute_1, { duration: 1, visibility: 'visible', strokeDashoffset: 0 })
      .to(miniroute_2, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_3, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_4, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_5, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_6, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_7, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_8, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_9, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_10, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_11, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(miniroute_12, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .add('stage-1')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5 }, '-=1')
      .add('stage-2')
      .add('stage-3')
      .add('stage-4')
      .to(miniroute_1, { duration: 0.1, visibility: 'hidden' })
      .to(miniroute_2, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_3, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_4, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_5, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_6, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_7, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_8, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_9, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_10, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_11, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(miniroute_12, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .add('stage-5')

      .to(body1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 })
      .to(body2, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 }, '-=0.1')
      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 0 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1 }, '-=1')
      .add('stage-6')

      .to(body2, { duration: 1, ease: 'power2.inOut', autoAlpha: 0 })
      .to(body1, { duration: 1, ease: 'power2.inOut', autoAlpha: 1 }, '-=1')
      .to(dot_5, { duration: 0.5, autoAlpha: 1 })
      .to(dot_6, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_7, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_8, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_9, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(dot_10, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label5, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label6, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label7, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label8, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label9, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(label10, { duration: 0.5, autoAlpha: 1 }, '-=0.5')
      .to(route_out_1, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_1.getTotalLength() * 2 }, '-=0.5')
      .to(route_out_2, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_2.getTotalLength() * 2 }, '-=1')
      .to(route_out_3, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_3.getTotalLength() * 2 }, '-=1')
      .to(route_out_4, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_4.getTotalLength() * 2 }, '-=1')
      .to(route_out_5, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_5.getTotalLength() * 2 }, '-=1')
      .to(route_out_6, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_6.getTotalLength() * 2 }, '-=1')
      .to(route_out_7, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_7.getTotalLength() * 2 }, '-=1')
      .to(route_out_8, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_8.getTotalLength() * 2 }, '-=1')
      .to(route_out_9, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_9.getTotalLength() * 2 }, '-=1')
      .to(route_out_10, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_10.getTotalLength() * 2 }, '-=1')
      .to(route_out_11, { duration: 1, visibility: 'visible', strokeDashoffset: route_out_11.getTotalLength() * 2 }, '-=1')
      .add('stage-7')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5 }, '-=1')
      .add('stage-8')
      .to(route_out_1, { duration: 0.1, visibility: 'hidden' })
      .to(route_out_2, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_3, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_4, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_5, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_6, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_7, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_8, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_9, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_10, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .to(route_out_11, { duration: 0.1, visibility: 'hidden' }, '-=0.1')
      .add('stage-9')
      .add('stage-10')

      .to(body1, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 0 })
      .to(body3, { duration: 0.1, ease: 'power2.inOut', autoAlpha: 1 })
      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 0 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1 }, '-=1')
      .to(city1, { duration: 0.2, autoAlpha: 1 })
      .to(city2, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city3, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city4, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city5, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city6, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city7, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city8, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city9, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city10, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .add('stage-11')

      .to(body3, { duration: 1, ease: 'power2.inOut', autoAlpha: 0 })
      .to(body4, { duration: 1, ease: 'power2.inOut', autoAlpha: 1 }, '-=1')
      .to(city11, { duration: 0.2, autoAlpha: 1 })
      .to(city12, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city13, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .to(city14, { duration: 0.2, autoAlpha: 1 }, '-=0.1')
      .add('stage-12')

      .to(body4, { duration: 1, ease: 'power2.inOut', autoAlpha: 0 })
      .to(body1, { duration: 1, ease: 'power2.inOut', autoAlpha: 1 }, '-=1')
      .to(route_top_1, { duration: 1, visibility: 'visible', strokeDashoffset: 0 })
      .to(route_top_2, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_3, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_4, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_5, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_6, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_7, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_8, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_9, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_10, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .to(route_top_11, { duration: 1, visibility: 'visible', strokeDashoffset: 0 }, '-=1')
      .add('stage-13')

      .to(overlay, { duration: 1, ease: 'power2.inOut', scale: 1 })
      .to(container, { duration: 1, ease: 'power2.inOut', scale: 1.5 }, '-=1')
      .add('stage-14')
      .add('stage-15')
      ;
    setTimeline(tl);
  }, []);

  useEffect(() => {
    if (!init) {
      if (timeline !== null) {
        setInit(true);
        timeline.seek(`stage-${stage}`);
        setLocalStage(stage);
      }
    }
  }, [init, stage, timeline]);
  useEffect(() => {
    let diff = Math.abs(localStage - stage);
    if (timeline !== null) {
      if (diff !== 0 && !transition) {
        setTransition(true);
        updateTransition(true);
        if (diff > 1) {
          refWrap.current.classList.add(styles.hide);
          setTimeout(() => {
            timeline.seek(`stage-${stage}`);
            refWrap.current.classList.remove(styles.hide);
            setTransition(false);
            setTimeout(() => {
              updateTransition(false);
            }, 800);
          }, 300);
        } else {
          let minimalDelay = false;
          let minimalDelayTimer = setTimeout(() => {
            minimalDelay = true;
          }, 800);
          timeline.tweenTo(`stage-${stage}`, {
            onComplete: function () {
              setTransition(false);
              clearTimeout(minimalDelayTimer);
              if (minimalDelay) {
                updateTransition(false);
              } else {
                setTimeout(() => {
                  updateTransition(false);
                }, 500);
              }
            }
          });
        }
        setLocalStage(stage);
      }
    }
  }, [localStage, stage, timeline, transition, updateTransition]);

  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.overlay} ref={refOverlay}></div>
        <div className={styles.container} ref={refContainer}>
          <div className={styles.body} ref={refBody1}>
            <div className={styles.labels}>
              <div className={`${styles.label} ${styles.label_1}`} ref={el => refLabels.current[0] = el} >布列斯特</div>
              <div className={`${styles.label} ${styles.label_2}`} ref={el => refLabels.current[1] = el} >斯维斯洛奇</div>
              <div className={`${styles.label} ${styles.label_3}`} ref={el => refLabels.current[2] = el} >布鲁兹吉</div>
              <div className={`${styles.label} ${styles.label_4}`} ref={el => refLabels.current[3] = el} >加里宁格勒</div>
              <div className={`${styles.label} ${styles.label_5}`} ref={el => refLabels.current[4] = el} >明斯克</div>
              <div className={`${styles.label} ${styles.label_6}`} ref={el => refLabels.current[5] = el} >圣彼得堡</div>
              <div className={`${styles.label} ${styles.label_7}`} ref={el => refLabels.current[6] = el} >莫斯科</div>
              <div className={`${styles.label} ${styles.label_8}`} ref={el => refLabels.current[7] = el} >下诺夫哥罗德</div>
              <div className={`${styles.label} ${styles.label_9}`} ref={el => refLabels.current[8] = el} >叶卡捷琳堡</div>
              <div className={`${styles.label} ${styles.label_10}`} ref={el => refLabels.current[9] = el} >克拉斯诺亚尔斯克</div>
              <div className={`${styles.label} ${styles.label_11}`} ref={el => refLabels.current[10] = el} >多斯特克</div>
              <div className={`${styles.label} ${styles.label_12}`} ref={el => refLabels.current[11] = el} >阿腾科里</div>
            </div>
            <div className={styles.svgs}>
              <div className={`${styles.svg} ${styles.svg_1}`} ref={refSvg1}>
                <svg width="2247" height="779" viewBox="0 0 2247 779" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="route">
                    <path ref={refRoute_top_9} d="M2104.5 231.435C1815 184.102 1208 189.935 1208 391.935C1208 465.935 1254.5 507.435 1340 533.435" stroke="url(#paint0_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_8} d="M1306 188C1258.5 198.5 1145 250.5 1145 347.5C1145 426 1231 495.5 1302 519" stroke="url(#paint1_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_2} d="M572 10C625.5 57.5 702.5 270.5 593.5 248.5" stroke="url(#paint2_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_1} d="M555.5 195C555.5 215.5 567.5 239 608 250" stroke="url(#paint3_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_4} d="M703 145C711 216 737 281 843.5 315.5" stroke="url(#paint4_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_3} d="M703 145C697 187 689.5 264 583 248.5" stroke="url(#paint5_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_5} d="M877.5 131C837.5 286 690.5 260.5 593.5 248.5" stroke="url(#paint6_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_6} d="M877.5 131C873.5 213 877 325.5 1001 384" stroke="url(#paint7_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_7} d="M1720.5 207.5C1619 209.5 1417.28 191.489 1197 256C1089.5 287.482 951 355 838 313.5" stroke="url(#paint8_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_right_1} d="M1761 539C1706.5 554.5 1475 582 1307.5 522" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_left_3} d="M442.5 276C505 250.5 533 241 651.5 261" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_left_2} d="M441.5 242C474 237 564 241.5 642.5 259.5" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    <mask id="maskMain1">
                      <path ref={refRoute_main_mask} d="M439.5 309.5C483.5 278 534 240.137 642 259.5C972.675 318.784 1178.3 521.836 1475 563.5C1580 578.245 1635 579 1730.5 576.5" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                    </mask>
                    <mask id="maskMain2">
                      <path ref={refRoute_main_mask2} d="M439.5 309.5C483.5 278 534 240.137 642 259.5C972.675 318.784 1178.3 521.836 1475 563.5C1580 578.245 1635 579 1730.5 576.5" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                    </mask>
                    <path ref={refRoute_main} d="M439.5 309.5C483.5 278 534 240.137 642 259.5C972.675 318.784 1178.3 521.836 1475 563.5C1580 578.245 1635 579 1730.5 576.5" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" mask="url(#maskMain1)" />
                    <path ref={refRoute_main2} d="M439.5 309.5C483.5 278 534 240.137 642 259.5C972.675 318.784 1178.3 521.836 1475 563.5C1580 578.245 1635 579 1730.5 576.5" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" mask="url(#maskMain2)" />
                    <path ref={refRoute_left_1} d="M381.5 207.5C509 225 523.5 234 663 263.5" stroke="#67D672" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_11} d="M1304.5 187C1198 196 1178.43 231.364 1006.5 289.5C937 313 856.5 321 796 298" stroke="url(#paint30_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRoute_top_10} d="M556 192C556 212.5 546.5 231.5 500 224" stroke="url(#paint31_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <g id="routes_out">
                    <path ref={refRouts_out_9} d="M2105 231.435C1815.5 184.102 1208.5 189.935 1208.5 391.935C1208.5 465.935 1255 507.435 1340.5 533.435" stroke="url(#paint9_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_8} d="M1306.5 188C1259 198.5 1145.5 250.5 1145.5 347.5C1145.5 426 1231.5 495.5 1302.5 519" stroke="url(#paint10_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_7} d="M572.5 10C626 57.5 703 270.5 594 248.5" stroke="url(#paint11_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_6} d="M703.5 145C711.5 216 737.5 281 844 315.5" stroke="url(#paint12_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_5} d="M703.5 145C697.5 187 690 264 583.5 248.5" stroke="url(#paint13_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_4} d="M878 131C838 286 691 260.5 594 248.5" stroke="url(#paint14_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_3} d="M878 131C874 213 877.5 325.5 1001.5 384" stroke="url(#paint15_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_2} d="M1721 207.5C1619.5 209.5 1417.78 191.489 1197.5 256C1090 287.482 951.5 355 838.5 313.5" stroke="url(#paint16_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_1} d="M556 195C556 215.5 568 239 608.5 250" stroke="url(#paint17_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_11} d="M555 195C555 215.5 542.5 231.5 496 224" stroke="url(#paint32_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refRouts_out_10} d="M1308 188C1201.5 197 1180.43 230.864 1008.5 289C939 312.5 858.5 320.5 798 297.5" stroke="url(#paint33_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <g id="miniroutes">
                    <path ref={refMiniroute_1} d="M440.5 244C310 244 156 263 1 403.5" stroke="url(#paint18_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_2} d="M440 244C292.111 267 132 323.5 22.5 528" stroke="url(#paint19_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_3} d="M443.5 282C325.5 282 256 322.5 207.5 373.5" stroke="url(#paint20_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_4} d="M443.5 282C334 307 264.5 364 219 472" stroke="url(#paint21_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_5} d="M439.103 314.103C399.475 334.402 364.674 371.01 334 425.344" stroke="url(#paint22_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_6} d="M444.371 313C411.156 342.652 385 410 385 468" stroke="url(#paint23_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_7} d="M1734 579C1734 603.333 1766 690 1809.5 746" stroke="url(#paint24_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_8} d="M1731 574C1750 616.167 1828.6 713.1 1975 777.5" stroke="url(#paint25_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_9} d="M1737 581C1779.67 622.333 1912.7 719.2 2103.5 776" stroke="url(#paint26_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_12} d="M1767 538C1799.5 547.5 1881 560.2 1939 563" stroke="url(#paint27_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_11} d="M1764.5 542C1804 562 1915.5 598.3 1999.5 617.5" stroke="url(#paint28_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path ref={refMiniroute_10} d="M1762.5 545.5C1844.5 599.667 2056.3 709.3 2245.5 720.5" stroke="url(#paint29_linear_6314_40224)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <g id="dots">
                    <g ref={refDot_12}>
                      <path d="M1740 576C1740 570.477 1735.52 566 1730 566C1724.48 566 1720 570.477 1720 576C1720 581.523 1724.48 586 1730 586C1735.52 586 1740 581.523 1740 576Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_11}>
                      <path d="M1773 538C1773 532.477 1768.52 528 1763 528C1757.48 528 1753 532.477 1753 538C1753 543.523 1757.48 548 1763 548C1768.52 548 1773 543.523 1773 538Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_4}>
                      <path d="M388 207C388 201.477 383.523 197 378 197C372.477 197 368 201.477 368 207C368 212.523 372.477 217 378 217C383.523 217 388 212.523 388 207Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_10}>
                      <path d="M2115 231C2115 225.477 2110.52 221 2105 221C2099.48 221 2095 225.477 2095 231C2095 236.523 2099.48 241 2105 241C2110.52 241 2115 236.523 2115 231Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_9}>
                      <path d="M1318 187C1318 181.477 1313.52 177 1308 177C1302.48 177 1298 181.477 1298 187C1298 192.523 1302.48 197 1308 197C1313.52 197 1318 192.523 1318 187Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_8}>
                      <path d="M888 132C888 126.477 883.523 122 878 122C872.477 122 868 126.477 868 132C868 137.523 872.477 142 878 142C883.523 142 888 137.523 888 132Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_6}>
                      <path d="M581 10C581 4.47715 576.523 0 571 0C565.477 0 561 4.47715 561 10C561 15.5228 565.477 20 571 20C576.523 20 581 15.5228 581 10Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_5}>
                      <path d="M565 194C565 188.477 560.523 184 555 184C549.477 184 545 188.477 545 194C545 199.523 549.477 204 555 204C560.523 204 565 199.523 565 194Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_7}>
                      <path d="M712 145C712 139.477 707.523 135 702 135C696.477 135 692 139.477 692 145C692 150.523 696.477 155 702 155C707.523 155 712 150.523 712 145Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_1}>
                      <path d="M448 311C448 305.477 443.523 301 438 301C432.477 301 428 305.477 428 311C428 316.523 432.477 321 438 321C443.523 321 448 316.523 448 311Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_2}>
                      <path d="M452 277C452 271.477 447.523 267 442 267C436.477 267 432 271.477 432 277C432 282.523 436.477 287 442 287C447.523 287 452 282.523 452 277Z" fill="#67D672" />
                    </g>
                    <g ref={refDot_3}>
                      <path d="M448 242C448 236.477 443.523 232 438 232C432.477 232 428 236.477 428 242C428 247.523 432.477 252 438 252C443.523 252 448 247.523 448 242Z" fill="#67D672" />
                    </g>
                  </g>

                  <defs>

                    <linearGradient id="paint0_linear_6314_40224" x1="1656.25" y1="207" x2="1656.25" y2="533.435" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_6314_40224" x1="1225.5" y1="188" x2="1225.5" y2="519" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_6314_40224" x1="557.5" y1="-25.5" x2="614" y2="333" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_6314_40224" x1="557.5" y1="-25.5" x2="614" y2="333" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_6314_40224" x1="700.5" y1="145" x2="686" y2="285.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint5_linear_6314_40224" x1="700.5" y1="145" x2="686" y2="285.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint6_linear_6314_40224" x1="878.5" y1="127.5" x2="797" y2="363.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint7_linear_6314_40224" x1="878.5" y1="127.5" x2="797" y2="363.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint8_linear_6314_40224" x1="2074" y1="122.5" x2="830.5" y2="286.5" gradientUnits="userSpaceOnUse">
                      <stop offset="0.5" stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint9_linear_6314_40224" x1="1493.5" y1="268.5" x2="2187" y2="241" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint10_linear_6314_40224" x1="1138" y1="496" x2="1301" y2="128.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint11_linear_6314_40224" x1="610.5" y1="315.5" x2="572.5" y2="-31" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint12_linear_6314_40224" x1="702.5" y1="316" x2="706.5" y2="145" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint13_linear_6314_40224" x1="702.5" y1="316" x2="706.5" y2="145" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint14_linear_6314_40224" x1="805.5" y1="361" x2="921.5" y2="115.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint15_linear_6314_40224" x1="805.5" y1="361" x2="921.5" y2="115.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint16_linear_6314_40224" x1="813.5" y1="314.5" x2="2427.5" y2="146" gradientUnits="userSpaceOnUse">
                      <stop offset="0.286458" stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint17_linear_6314_40224" x1="633" y1="284" x2="569" y2="182.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint18_linear_6314_40224" x1="220.75" y1="244" x2="220.75" y2="403.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint19_linear_6314_40224" x1="231.25" y1="244" x2="68.5" y2="504" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint20_linear_6314_40224" x1="325.5" y1="282" x2="245.5" y2="363.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint21_linear_6314_40224" x1="331.25" y1="282" x2="198.5" y2="477" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint22_linear_6314_40224" x1="395.017" y1="308.051" x2="313.5" y2="450" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint23_linear_6314_40224" x1="405.971" y1="317.59" x2="336.5" y2="468" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="0.692708" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint24_linear_6314_40224" x1="1771.75" y1="579" x2="1771.75" y2="746" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint25_linear_6314_40224" x1="1853" y1="574" x2="1853" y2="777.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint26_linear_6314_40224" x1="1920.25" y1="581" x2="1920.25" y2="776" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint27_linear_6314_40224" x1="1853" y1="538" x2="1853" y2="563" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint28_linear_6314_40224" x1="1882" y1="542" x2="1882" y2="617.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint29_linear_6314_40224" x1="2004" y1="545.5" x2="2004" y2="720.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint30_linear_6314_40224" x1="1306.5" y1="185" x2="727" y2="285.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint31_linear_6314_40224" x1="622.5" y1="166" x2="463" y2="226" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint32_linear_6314_40224" x1="482.5" y1="244" x2="558.5" y2="204" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="paint33_linear_6314_40224" x1="1139.5" y1="496" x2="1302.5" y2="128.5" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#67D672" />
                      <stop offset="1" stopColor="#67D672" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

            </div>
            <div className={styles.bg} ref={refBg}>
              <div className={styles.bg__overlay} ref={refBgOverlay}></div>
              <img src={`${path}/img/map-services-ch.webp`} alt="" />
            </div>

          </div>
          <div className={styles.body} ref={refBody2}>
            <div className={styles.points}>
              <div className={styles.point}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div className={styles.labels}>
              <div className={`${styles.label} ${styles.label_13}`} ref={el => refLabels.current[12] = el} >俄罗斯，加里宁格勒</div>
            </div>
            <div className={styles.bg} ref={refBg}>
              <img src={`${path}/img/map-services-2-ch.webp`} alt="" />
            </div>

          </div>

          <div className={styles.body} ref={refBody3}>
            <div className={styles.cities}>
              <div className={`${styles.city} ${styles.city_1}`} ref={el => refCities.current[0] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>沃罗丁斯克</div>
                  <div className={styles.city__desc}>500  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_2}`} ref={el => refCities.current[1] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>沃尔西诺</div>
                  <div className={styles.city__desc}>43420  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_3}`} ref={el => refCities.current[2] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>克列斯特</div>
                  <div className={styles.city__desc}>1818  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_4}`} ref={el => refCities.current[3] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>谢利亚蒂诺</div>
                  <div className={styles.city__desc}>13036  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_5}`} ref={el => refCities.current[4] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>西里卡特娜娅</div>
                  <div className={styles.city__desc}>586  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_6}`} ref={el => refCities.current[5] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>白拉斯特</div>
                  <div className={styles.city__desc}>35538  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_7}`} ref={el => refCities.current[6] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>霍夫里诺</div>
                  <div className={styles.city__desc}>1362  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_8}`} ref={el => refCities.current[7] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>库帕夫纳</div>
                  <div className={styles.city__desc}>4432  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_9}`} ref={el => refCities.current[8] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>埃列克特罗乌格利</div>
                  <div className={styles.city__desc}>28734  标箱</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_10}`} ref={el => refCities.current[9] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>思博尔纳雅-乌格利娜娅</div>
                  <div className={styles.city__desc}>200  标箱</div>
                </div>
              </div>
            </div>
            <div className={styles.bg} ref={refBg}>
              <img src={`${path}/img/map-services-3.webp`} alt="" />
            </div>

          </div>

          <div className={styles.body} ref={refBody4}>
            <div className={styles.cities}>
              <div className={`${styles.city} ${styles.city_11}`} ref={el => refCities.current[10] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>布朗卡</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_12}`} ref={el => refCities.current[11] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>新港</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_13}`} ref={el => refCities.current[12] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>阿夫托沃</div>
                </div>
              </div>
              <div className={`${styles.city} ${styles.city_14}`} ref={el => refCities.current[13] = el} >
                <div className={styles.city__point}></div>
                <div className={styles.city__info}>
                  <div className={styles.city__name}>舒沙里</div>
                </div>
              </div>
            </div>
            <div className={styles.bg} ref={refBg}>
              <img src={`${path}/img/map-services-4.webp`} alt="" />
            </div>

          </div>
        </div>
      </div>
    </>
  );

}

export default Map;
